import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepWelcome from '../components/onboarding/steps/StepWelcome';
import StepAddAsset from '../components/onboarding/steps/StepAddAsset';
import StepAddLiability from '../components/onboarding/steps/StepAddLiability';
import StepBusinessEquity from '../components/onboarding/steps/StepBusinessEquity';
import StepReveal from '../components/onboarding/steps/StepReveal';

const TOTAL_STEPS = 5;

const Onboarding: React.FC = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [assetAdded, setAssetAdded] = useState(false);
  const [businessEquityFraction, setBusinessEquityFraction] = useState(0);


  const completeOnboarding = () => {
    localStorage.setItem('wealthini_onboarding_complete', 'true');
    localStorage.setItem('wealthini_show_welcome_hint', 'true');
    localStorage.removeItem('wealthini_force_onboarding');
    navigate('/', { replace: true });
  };

  const onNext = () => {
    if (currentStep === TOTAL_STEPS) {
      completeOnboarding();
    } else {
      if (currentStep === 4) setBusinessEquityFraction(0);
      setCurrentStep((s) => s + 1);
    }
  };

  const onBack = () => {
    setCurrentStep((s) => Math.max(1, s - 1));
  };

  const progressPct = currentStep === 4
    ? ((3 + businessEquityFraction) / (TOTAL_STEPS - 1)) * 100
    : ((currentStep - 1) / (TOTAL_STEPS - 1)) * 100;

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      {/* Progress header */}
      <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 border-b border-white/10 bg-black/20 backdrop-blur flex items-center justify-between">
        <span className="text-white font-semibold text-lg">💰 Wealthini</span>

        <div className="flex flex-col items-center gap-1">
          <span className="text-sm text-white/50">
            Step {currentStep} of {TOTAL_STEPS}{(currentStep === 3 || currentStep === 4) ? ' (optional)' : ''}
          </span>
          <div className="w-48 h-1 bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full bg-purple-500 rounded-full transition-all duration-300"
              style={{ width: `${progressPct}%` }}
            />
          </div>
        </div>

        <button
          type="button"
          className="text-sm text-white/40 hover:text-white transition-colors"
          onClick={completeOnboarding}
        >
          Skip setup →
        </button>
      </header>

      {/* Main content */}
      <main className="max-w-2xl mx-auto px-4 pt-24 pb-12">
        {currentStep >= 2 && currentStep <= 3 && (
          <button
            type="button"
            onClick={onBack}
            className="text-sm text-white/40 hover:text-white transition-colors mb-6"
          >
            ← Back
          </button>
        )}

        {currentStep === 1 && (
          <StepWelcome onNext={onNext} />
        )}
        {currentStep === 2 && (
          <StepAddAsset
            onNext={(added) => { setAssetAdded(added); onNext(); }}
            onPlaidComplete={completeOnboarding}
          />
        )}
        {currentStep === 3 && (
          <StepAddLiability onNext={onNext} assetAdded={assetAdded} />
        )}
        {currentStep === 4 && (
          <StepBusinessEquity
            onNext={onNext}
            onBack={onBack}
            onViewChange={(fraction) => setBusinessEquityFraction(fraction)}
          />
        )}
        {currentStep === 5 && (
          <StepReveal onComplete={completeOnboarding} />
        )}
      </main>
    </div>
  );
};

export default Onboarding;
